var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diy-container view-container"},[_c('div',{staticClass:"diy-wrapper view-wrapper"},[_c('page-wrapper',{attrs:{"imgBg":_vm.imgBg01}},[_c('text-wrapper',{attrs:{"height":_vm.textWrapperHeight,"bgColor":'rgba(0,0,0,0.5)'}},[_c('h2',{staticClass:"fancy-header --margin-0 --font-weight-400"},[_vm._v("Coming Soon.. . ")])])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }